@if (inited) {
  <sm-toolbar>
    <p-button icon="fas fa-save" label="Speichern" (onClick)="save()">
    </p-button>
  </sm-toolbar>
  <div class="grid">
    <p-card class="col-12 xl:col-6">
      <sm-form [form]="form">
      </sm-form>
      @if (lesson.changedBy != '') {
        <span>Geändert von {{lesson.changedBy}} am {{lesson.changedDate | date:'dd.MM.yyyy HH:mm:ss'}}</span>
      }
    </p-card>
    <div class="col-12 xl:col-6">
      <div class="grid mb-1 mt-1">
        <p-checkbox appLabel="Abwesenheit geprüft" name="missingPupilsChecked" [(ngModel)]="lesson.missingPupilsChecked" [binary]=true></p-checkbox>
      </div>
      <p-table class="compact p-datatable-gridlines" [value]="pupilRows">
        <ng-template pTemplate="header">
          <tr>
            <th [style]="{width: '10%'}">#</th>
            @if (lesson.course != null) {
                <th [style]="{width: '15%'}">Klasse</th>
                <th [style]="{width: '25%'}">Name</th>
                <th [style]="{width: '25%'}">Anwesenheit</th>
                <th [style]="{width: '25%'}">Bemerkung</th>
            }
            @else {
                <th [style]="{width: '30%'}">Name</th>
                <th [style]="{width: '30%'}">Anwesenheit</th>
                <th [style]="{width: '30%'}">Bemerkung</th>
            }
        </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-index="rowIndex">
          <tr [pSelectableRow]="row">
            <td class="text-right">{{index + 1}}</td>
            @if (lesson.course != null) {
                <td>{{row.pupil.getClassDisplayName()}}</td>
            }
            <td>{{row.pupil.getFullName()}}</td>
            <td>
              <p-checkbox name="missing" [(ngModel)]="row.lessonPupil.missing" [trueValue]=false [falseValue]=true [binary]=true></p-checkbox>
              <tag-button class="sn ml-2" [value]="row.sickNote == null ? 'Abmeldung eintragen' : _Strings.crop(row.sickNote.reason, 15)" [severity]="row.sickNote == null ? 'warn' : 'danger'" [active]="row.sickNote" [clickable]="!row.sickNote" (onClick)="addSickNote(row)"></tag-button>
            </td>
            <td pEditableColumn>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText [(ngModel)]="row.lessonPupil.note" (onFocus)="_GuiUtils.selectAll($event)">
                </ng-template>
                <ng-template pTemplate="output">
                  {{row.lessonPupil.note}}
                </ng-template>
              </p-cellEditor>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <tr>
            <td><strong>{{getNumPresent()}}/{{pupilRows.length}} anwesend</strong></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}
